export default "__VITE_ASSET__Bx0NqH0k__"